import React from 'react'

export const Tracker = React.lazy(() => import('./Tracker').then(({ Tracker }) => ({ default:Tracker })))
